/**
 * Detects whether the app is running on an iPad.
 *
 * iPadOS 13+ Safari (and the WebKit-based Chrome/Firefox/Edge on iPadOS)
 * masquerade as desktop Safari: the user agent contains "Macintosh" instead
 * of "iPad". Such a device is told apart from a real Mac by its touch
 * capability, which only an iPad has.
 */
export default function isIpad(): boolean {
    if (typeof navigator === 'undefined') return false;

    const userAgent = navigator.userAgent ?? '';

    // Classic iPad user agent (iPadOS 12 and earlier, and some browsers).
    if (/iPad/.test(userAgent)) return true;

    // iPadOS 13+ reports as "Macintosh" but, unlike a real Mac, is touch-capable.
    return /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;
}
